import React from 'react'

import {SkeletonLoader} from '@daedalus/atlas/SkeletonLoader'

import {CheckInCheckOutProps} from './CheckInCheckOut'
import {PrimaryLoadingWrapper, SecondaryRow, Wrapper} from './styles'

export const CheckInCheckOutLoading: React.FC<
  Pick<CheckInCheckOutProps, 'layout'>
> = ({layout}) => {
  if (layout === 'secondary')
    return (
      <Wrapper>
        <SecondaryRow justifyContent="space-between">
          <SkeletonLoader width={58} height={22} />
          <SkeletonLoader width={58} height={22} />
        </SecondaryRow>
        <SecondaryRow justifyContent="space-between">
          <SkeletonLoader width={80} height={24} />
          <SkeletonLoader width={80} height={24} />
        </SecondaryRow>
        <SecondaryRow justifyContent="space-between">
          <SkeletonLoader width={120} height={22} />
          <SkeletonLoader width={80} height={22} />
        </SecondaryRow>
      </Wrapper>
    )
  return (
    <PrimaryLoadingWrapper>
      <div>
        <SkeletonLoader width={64} height={24} />
        <SkeletonLoader width={127} height={24} />
      </div>
      <div>
        <SkeletonLoader width={64} height={24} />
        <SkeletonLoader width={127} height={24} />
      </div>
    </PrimaryLoadingWrapper>
  )
}
